import {Action} from "./actions"
import {ACTION_TYPES, Actions} from "./types"

export const ProductAction = Action
export const PRODUCT_ACTION_TYPES = ACTION_TYPES
export type ProductActions = Actions


// WEBPACK FOOTER //
// ./src/state/product/actions/index.ts